import { render, staticRenderFns } from "./assignmentbrief.html?vue&type=template&id=20f58218&scoped=true&"
import script from "./assignmentbrief.js?vue&type=script&lang=js&"
export * from "./assignmentbrief.js?vue&type=script&lang=js&"
import style0 from "./assignmentbrief.css?vue&type=style&index=0&id=20f58218&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20f58218",
  null
  
)

export default component.exports